export default "__VITE_ASSET__Ser6oBbi__"